// @ts-nocheck
/* eslint-disable */
/* This file was generated by Unframer for Framer project 87f9c755347dad76 "VastiPost", do not edit manually */
"use client";

/**
 * @typedef Locale
 * string
 */

/**
 * @typedef {{
 * children?: React.ReactNode
 * locale?: Locale
 * style?: React.CSSProperties
 * className?: string
 * id?: string
 * ref?: any
 * width?: any
 * height?: any
 * layoutId?: string
 * bellVariant?: 'Variant 1' | 'Variant 2' | 'Variant 3' | 'Variant 4' // Bell Variant
 * profileVariant?: 'Variant 1' | 'Variant 2' // Profile Variant
 * milestone/AdStudio?: 'Variant 1' | 'Variant 2' | 'Variant 3' | 'Variant 4' // Milestone/AdStudio
 * statusBarPlaceholder?: boolean // StatusBarPlaceholder
}} Props

 */
import { stdin_default } from "./chunks/chunk-WD6W7B4H.js";
import "./chunks/chunk-OWR2SEAK.js";
import "./chunks/chunk-YLYLQJJC.js";
import { routes } from "./chunks/chunk-QHTAN6EJ.js";

// virtual:nav-bar
import { Fragment } from "react";
import { ContextProviders } from "unframer";
import { WithFramerBreakpoints } from "unframer";
import { jsx } from "react/jsx-runtime";
var locales = [];
var defaultResponsiveVariants = {};
/** @type {function(Props): any} */
function ComponentWithRoot({ locale, ...rest }) {
	return (
		<ContextProviders
			routes={routes}
			framerSiteId={
				"87f9c755347dad76fedd65c32355276920a85144cd0f57411ebe1b0bdf0c38db"
			}
			locale={locale}
			locales={locales}
		>
			{jsx(stdin_default, {
				...rest,
			})}
		</ContextProviders>
	);
}
/**
 * @type {import("unframer").UnframerBreakpoint}
 * Represents a responsive breakpoint for unframer.
 */

/**
 * @typedef VariantsMap
 * Partial record of UnframerBreakpoint to Props.variant, with a mandatory 'base' key.
 * { [key in UnframerBreakpoint]?: Props['variant'] } & { base: Props['variant'] }
 */

/**
 * Renders NavBarFramerComponent for all breakpoints with a variants map. Variant prop is inferred per breakpoint.
 * @function
 * @param {Omit<Props, 'variant'> & {variants?: VariantsMap}} props
 * @returns {any}
 */
ComponentWithRoot.Responsive = ({ locale = "", ...rest }) => {
	return (
		<ContextProviders
			routes={routes}
			framerSiteId={
				"87f9c755347dad76fedd65c32355276920a85144cd0f57411ebe1b0bdf0c38db"
			}
			locale={locale}
			locales={locales}
		>
			<WithFramerBreakpoints
				Component={stdin_default}
				variants={defaultResponsiveVariants}
				{...rest}
			/>
		</ContextProviders>
	);
};
Object.assign(ComponentWithRoot, stdin_default);
var nav_bar_default = ComponentWithRoot;
export { nav_bar_default as default };
